import React from "react";
import { useTranslate } from "@refinedev/core";
import { AppstoreOutlined, TagsOutlined, WalletOutlined } from "@ant-design/icons";
import { TabHub } from "../../components/TabHub";
import { ProductList } from "../products/list";
import { PricingPlanList } from "../pricing-plans/list";
import { CreditPackList } from "../credit-packs/list";

/**
 * Catalogue hub — what we sell and for how much.
 *
 * Deliberately top-level rather than under Configuration: these are business
 * records with a weekly-or-faster edit cadence, not tenant configuration.
 */
export const CatalogPage: React.FC = () => {
  const _t = useTranslate();

  return (
    <div className="max-w-7xl mx-auto">
      <TabHub
        title={_t("catalog.catalog", "Catalog")}
        subtitle={_t("catalog.subtitle", "")}
        items={[
          {
            key: "products",
            label: _t("catalog.tabs.products", "Products"),
            icon: <AppstoreOutlined />,
            children: <ProductList hideHeader />,
          },
          {
            key: "plans",
            label: _t("catalog.tabs.plans", "Pricing plans"),
            icon: <TagsOutlined />,
            children: <PricingPlanList hideHeader />,
          },
          {
            key: "credit-packs",
            label: _t("catalog.tabs.creditPacks", "Credit packs"),
            icon: <WalletOutlined />,
            children: <CreditPackList hideHeader />,
          },
        ]}
      />
    </div>
  );
};
